module.exports = __webpack_public_path__ + "static/img/contents-bottom@t.1da6d3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-chem-pr-portal/contents-bottom@t.jpg
// module id = V6zC
// module chunks = 0